export const commonHeights = [15, 16, 17, 18];
export const mediumLargeHeights = [17, 18, 19, 20];
